export default "/images/vendor/flag-icon-css/flags/1x1/gh.svg?286f4413bbf14d667ea8cbb147279a4e";